import { Injectable } from '@angular/core';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { Observable } from 'rxjs';
import { KoanCardData } from '../../../../../../../models/print-cards/koan-card-data';

@Injectable()
export class KoanBusinessCardStackContentViewModel extends PrintCardContentViewModel {
  public readonly cardData$: Observable<KoanCardData>;
}
